import * as React from "react"

import { cn } from "@/lib/utils"

function Textarea({ className, ...props  }: React.ComponentProps<"textarea">) {
  console.log(props);
  return (
    <textarea
      data-slot="textarea"
      maxLength={props.maxLength}
      className={cn(
        "border-input placeholder:text-muted-foreground focus-visible:border-ring focus-visible:ring-ring/50 aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive dark:bg-input/30 flex field-sizing-fixed min-h-16 min-w-0 w-full max-w-full resize-y overflow-x-hidden whitespace-pre-wrap wrap-break-word rounded-md border bg-transparent px-3 py-2 text-base shadow-xs transition-[color,box-shadow] outline-none focus-visible:ring-[3px] disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
        className
      )}
      {...props}
    />
  )
}

export { Textarea }
